import { axios, path } from './config';

export function getDLCForm({ customerId }) {
  return axios.get(path.GET_DLC_FORM, { customer_id: customerId });
}

export function createDLCForm({ formData }) {
  const bodyFormData = new FormData();
  bodyFormData.append('ten_dlc_registration', JSON.stringify(formData));
  return axios.post(path.CREATE_DLC_FORM, bodyFormData);
}
